import { updateContent } from 'actions/ContentActions';
import { ArrayToDropdownItems } from 'commons/DropdownUtils';
import { Platform } from '@visikon/core-models';
import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, DropdownProps } from 'semantic-ui-react';
import { entrySelector } from '../ArchiveHeader';
import { CustomType } from '@visikon/core-models/content';

export function PlatformMedicalSpecialityDropdown({ id, type }: ITypeHeaderProps) {
  const entry = useSelector(entrySelector(id, type)) as CustomType & Platform.PlatformMigration;
  const dispatch = useDispatch();

  const onChange = (_event: React.SyntheticEvent, data: DropdownProps) => {
    if (!entry) return;

    const selectedSpecialities = data.value as string[];
    entry.platformSpecialties = selectedSpecialities;
    dispatch(updateContent(entry));
  };

  return (
    <Dropdown
      multiple
      selection
      search
      options={ArrayToDropdownItems(Platform.PLATFORM_MEDICAL_SPECIALITIES)}
      placeholder="Choose speciality"
      value={entry?.platformSpecialties || []}
      onChange={onChange}
      disabled={!entry}
      minCharacters={2}
    />
  );
}
